export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2740_19269)">
                <path
                    d="M24.75 12.8752C24.9427 12.8905 26.2531 12.8558 26.4375 12.8752C29.8125 12.8752 31.5 15.6706 31.5 17.9377C31.5 19.0627 30.9375 21.3127 29.1756 22.6331C28.9822 22.7577 27.7721 22.8801 27.5625 23.0002"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path
                    d="M10.9922 12.875C9.99219 12.875 8.49219 12.875 6.49219 12.875C6.80377 13.5589 8.21849 16.6219 8.99943 16.8125"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 3.875C18.3107 3.875 18.5919 4.00093 18.7955 4.20454C18.9991 4.40812 19.125 4.68935 19.125 5C19.125 5.31065 18.9991 5.59188 18.7955 5.79546C18.5919 5.99907 18.3107 6.125 18 6.125C17.6893 6.125 17.4081 5.99907 17.2045 5.79546C17.0009 5.59188 16.875 5.31065 16.875 5C16.875 4.68935 17.0009 4.40812 17.2045 4.20454C17.4081 4.00093 17.6893 3.875 18 3.875Z"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path
                    d="M27.9569 29.6735C27.9706 29.5343 27.9835 29.3946 27.9955 29.2544C28.0807 28.2644 28.125 27.2488 28.125 26.2138C28.125 21.2955 27.1254 16.8145 25.4859 13.4447C23.6341 9.63859 20.966 7.25 18 7.25C15.0219 7.25 12.3441 9.65822 10.4914 13.4917C8.8654 16.8561 7.875 21.3183 7.875 26.2138C7.875 27.2693 7.92104 28.3047 8.00957 29.3132C8.0224 29.4594 8.03612 29.605 8.05072 29.75"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path d="M11.25 12.875H25.875" stroke="black" strokeWidth="1.5" />
                <path d="M16.875 26.375H19.125" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <rect x="6.375" y="29.375" width="23.25" height="3" rx="1.5" stroke="black" strokeWidth="1.5" />
            </g>
            <defs>
                <clipPath id="clip0_2740_19269">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
